type tLocale = {
  [key: string]: string;
};

export const LOCALE: tLocale = {
  selectAll: 'xref-ag-grid-select-all',
  searchOoo: 'xref-ag-grid-search',
  filterOoo: 'xref-ag-grid-filter',

  //! Filter Buttons
  applyFilter: 'xref-ag-grid-apply-filter',
  resetFilter: 'xref-ag-grid-reset-filter',
  clearFilter: 'xref-ag-grid-clear-filter',

  //! Menu
  pinColumn: 'xref-ag-grid-pin-column',
  pinLeft: 'xref-ag-grid-pin-left',
  pinRight: 'xref-ag-grid-pin-right',
  noPin: 'xref-ag-grid-no-pin',
  autosizeThiscolumn: 'xref-ag-grid-auto-size-this-column',
  autosizeAllColumns: 'xref-ag-grid-auto-size-all-column',
  resetColumns: 'xref-ag-grid-reset-column',
  copy: 'xref-ag-grid-copy',
  copyWithHeaders: 'xref-ag-grid-copy-with-headers',
  paste: 'xref-ag-grid-paste',
  export: 'xref-ag-grid-export',
  csvExport: 'xref-ag-grid-export-csv',
  excelExport: 'xref-ag-grid-export-excel',

  //! Number Filter
  blank: 'xref-ag-grid-blank',
  notBlank: 'xref-ag-grid-notblank',
  equals: 'xref-ag-grid-equals',
  notEqual: 'xref-ag-grid-notequal',
  greaterThan: 'xref-ag-grid-greaterthan',
  greaterThanOrEqual: 'xref-ag-grid-greaterthanequal',
  lessThan: 'xref-ag-grid-lessthan',
  lessThanOrEqual: 'xref-ag-grid-lessthanorequal',
  inRange: 'xref-ag-grid-inrange',
  inRangeStart: 'xref-ag-grid-from',
  inRangeEnd: 'xref-ag-grid-to',

  //! Filter Conditions
  andCondition: 'xref-ag-grid-and',
  orCondition: 'xref-ag-grid-or',
  
  // ! Footer
  page: 'xref-page',
  to: 'xref-to',
  of: 'xref-of'
};